module.exports = __webpack_public_path__ + "static/img/logo.f1a92b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo.png
// module id = Pl8J
// module chunks = 1